const removeEmptyProperties = (obj) => Object.fromEntries(
    Object.entries(obj)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, v === Object(v) ? removeEmptyProperties(v) : v]),
);

const ObjectUtils = {
    removeEmptyProperties,
};

export default ObjectUtils;



/** WEBPACK FOOTER **
 ** ./src/services/object-utils.js
 **/